import { render, staticRenderFns } from "./adb-form-item.vue?vue&type=template&id=57ef4782&scoped=true&"
import script from "./adb-form-item.vue?vue&type=script&lang=js&"
export * from "./adb-form-item.vue?vue&type=script&lang=js&"
import style0 from "./adb-form-item.vue?vue&type=style&index=0&id=57ef4782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ef4782",
  null
  
)

export default component.exports